<!-- Gauche : bouton Retour -->
<button
  type="button"
  (click)="goBack()"
  class="justify-self-start border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
>
  <app-svg class="fg-gris-1 shrink-0" height="20" svgPath="assets/svg/arrow-back.svg" width="20" />
  {{ 'common.back' | translate }}
</button>

<!-- Centre : filtres + recherche -->
<div class="flex items-center gap-[10px]">
  @for (f of filters; track f.value) {
    <button
      type="button"
      class="flex items-center gap-[10px] h-[48px] px-[15px] py-[9px] rounded-[30px] cursor-pointer transition-colors shrink-0"
      [class]="activeFilter() === f.value ? f.bg : 'bg-white border ' + f.border"
      (click)="filterChange.emit(f.value)"
    >
      <div
        class="size-[10px] rounded-full shrink-0"
        [class]="activeFilter() === f.value ? 'bg-white' : f.bg"
      ></div>
      <span
        class="text-[19px] font-semibold whitespace-nowrap"
        [class]="activeFilter() === f.value ? 'text-white' : f.fg"
        >{{ f.labelKey | translate }}</span
      >
      <div class="relative size-[25px] flex items-center justify-center shrink-0">
        <div
          class="absolute inset-0 rounded-full"
          [class]="activeFilter() === f.value ? 'bg-white' : f.bg"
        ></div>
        <span
          class="relative text-[14px] font-semibold"
          [class]="activeFilter() === f.value ? f.fg : 'text-white'"
          >{{ counts()[f.value] ?? 0 }}</span
        >
      </div>
    </button>
  }

  <label
    class="flex items-center gap-[10px] h-[48px] px-[20px] rounded-[5px] w-[300px] max-w-[300px] min-w-[150px] overflow-hidden border border-gris-3 cursor-text transition-colors hover:border-gris-2 focus-within:border-bleu-1"
  >
    <input
      type="text"
      class="flex-1 text-[16px] fg-noir-2 outline-none bg-transparent min-w-0 border-none"
      [value]="searchQuery()"
      (input)="searchChange.emit($any($event.target).value)"
      [placeholder]="'order_list.search_placeholder' | translate"
    />
    <app-svg class="fg-gris-2 shrink-0" height="20" svgPath="assets/svg/search.svg" width="20" />
  </label>
</div>

<!-- Droite : total + annuler -->
<div class="flex items-center gap-[10px] justify-end">
  <div
    class="bg-noir-1 rounded-[5px] h-[60px] w-[130px] flex flex-col items-center justify-center gap-[3px]"
  >
    <span class="text-white text-[14px] font-medium leading-none">
      {{ 'order_list.collected' | translate }}
    </span>
    <span class="text-white text-[19px] font-bold leading-none">
      {{ totalCollectedFormatted() }}
    </span>
  </div>
</div>
